import React from 'react';
import classNames from 'classnames';
import InstantConfirm from '@lt/components/icons-react/rebrand/Instant';
import { useTranslation } from '@lt/localization';
import type { CurrencyType } from 'src/utils/stringUtils';
import { CurrencyFormat } from '@lt/components';
import type { Availability } from '../../types';
import HotelCardAvailability from '../HotelCardAvailability';
import HotelCardDates from './components/HotelCardDates/HotelCardDates';
import styles from './hotelCardPrice.module.css';

type HotelCardPriceProps = {
  instantConfirm: boolean;
  isMobile: boolean;
  isFlexDates: boolean;
  isMapCard: boolean;
  price: number;
  currencyCode: CurrencyType;
  availability: Availability;
  isHotelOnly: boolean;
  datesInfo?: string;
};

const HotelCardPrice: React.FC<HotelCardPriceProps> = ({
  isMobile,
  instantConfirm,
  isFlexDates,
  isMapCard,
  price,
  currencyCode,
  availability,
  isHotelOnly,
  datesInfo = '',
}) => {
  const { t } = useTranslation();

  const showInstantConfirmIcon = instantConfirm && !isHotelOnly;

  return (
    <div className={styles.container}>
      <div className={styles.priceContainer}>
        <div
          className={classNames(styles.styledHotelCardPrice, {
            [styles.styledHotelCardPriceMobile]: isMobile,
          })}
        >
          {showInstantConfirmIcon && (
            <InstantConfirm className={styles.instantConfirmIcon} />
          )}
          <div
            className={classNames(styles.styledPrice, {
              [styles.styledPriceMapCard]: isMapCard,
              [styles.styledPriceMobile]: isMobile,
              [styles.styledPriceDesktop]: !isMobile && !isMapCard,
            })}
          >
            <span>{t('filters.prices.from')} </span>
            <CurrencyFormat value={price} currencyCode={currencyCode} />
          </div>
        </div>

        <HotelCardAvailability
          availability={availability}
          isHotelOnly={isHotelOnly}
          isCompact
        />
      </div>
      {isFlexDates ? <HotelCardDates datesInfo={datesInfo} /> : null}
    </div>
  );
};

export default HotelCardPrice;
